import React from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';
import ContactGeneral from './ContactGeneral';
import './ContactDetail.less';

class ContactDetail extends React.Component {

   render() {
      const { contactId } = this.props.params;
      return (
         <div className="ContactDetail" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to={`/contact/detail/${contactId}`} activeStyle={{ color: 'red' }} >Contact Details</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to={`/contact/detail/${contactId}/address`}
                                activeStyle={{ color: 'red' }} >Addresses</IndexLink>
                  </li>
                  <li>
                     <Link to={`/contact/detail/${contactId}/invoice`}
                           activeStyle={{ color: 'red' }} >Invoices</Link>
                  </li>
                  <li>
                     <Link to={`/contact/detail/${contactId}/stockItems`}
                           activeStyle={{ color: 'red' }} >Stock</Link>
                  </li>
               </ul>
            </Navbar>
            <ContactGeneral contactId={contactId} />
            <hr/>
            {this.props.children}
         </div>
      );
   }
}
ContactDetail.propTypes = {
   children: React.PropTypes.object,
   params: React.PropTypes.object
};

export default ContactDetail;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactDetail.js
 **/